import { useEffect, useState } from "react";
import { Bookmark } from "lucide-react";
import { isBookmarked, toggleBookmark } from "../lib/journey";
import { markFeatureTried } from "../lib/settings";
import type { NodeType } from "../lib/db";

// A small icon-only toggle that sits beside a detail-page title. Filled + warm when bookmarked,
// outline + muted otherwise. Theme tokens only (no hardcoded amber) so it survives day/night.
export function BookmarkButton({
  nodeType,
  nodeId,
  title,
}: {
  nodeType: NodeType;
  nodeId: string;
  title: string;
}) {
  const [on, setOn] = useState(false);

  useEffect(() => {
    let cancelled = false;
    isBookmarked(nodeType, nodeId).then((v) => {
      if (!cancelled) setOn(v);
    });
    return () => {
      cancelled = true;
    };
  }, [nodeType, nodeId]);

  return (
    <button
      type="button"
      className={"icon-btn bookmark-btn print:hidden" + (on ? " is-on" : "")}
      onClick={async () => {
        const next = await toggleBookmark({ nodeType, nodeId, title });
        setOn(next);
        if (next) void markFeatureTried("bookmark");
      }}
      aria-pressed={on}
      aria-label={on ? "Remove bookmark" : "Bookmark this for later"}
      title={on ? "Remove bookmark" : "Bookmark this for later"}
    >
      <Bookmark size={17} fill={on ? "currentColor" : "none"} />
    </button>
  );
}
